export default {
    // Header Section
    "discover_your": "Discover Your",
    "love_report": "Love Report",
    "cosmic_love_insights": "Cosmic Love Insights",
    "love_report_description": "Unlock the secrets of your romantic destiny with comprehensive love and relationship analysis based on Vedic astrology. Get insights into compatibility, marriage timing, soulmate characteristics, and personalized guidance for lasting love.",

    // Service Information
    "enter_details_for_love_analysis": "Enter Your Details for Love Analysis",
    "complete_love_analysis": "Complete Love Analysis",
    "service_price": "Service Price",
    "comprehensive_love_analysis_note": "Deep analysis of your romantic potential and relationship compatibility",

    // Form Fields
    "full_name": "Full Name",
    "enter_full_name": "Enter your full name",
    "name_love_vibration": "Your name influences your romantic vibrations and attraction patterns",
    "email_address": "Email Address",
    "enter_email_address": "Enter your email address",
    "phone_number": "Phone Number",
    "enter_phone_number": "Enter your phone number",
    "gender": "Gender",
    "male": "Male",
    "female": "Female",
    "other": "Other",
    "date_of_birth": "Date of Birth",
    "birth_date_love_compatibility": "Essential for determining your love and compatibility patterns",
    "time_of_birth": "Time of Birth",
    "exact_time_critical_for_love": "Precise time needed for accurate Venus and 7th house calculations",
    "place_of_birth": "Place of Birth",
    "place_of_birth_placeholder": "City, State, Country",
    "location_essential_for_love": "Location affects planetary positions influencing love and relationships",
    "preferred_language": "Preferred Language",
    "english": "English",
    "hindi": "Hindi",
    "telugu": "Telugu",
    "kannada": "Kannada",
    "language_note": "Your love analysis will be delivered in the selected language",

    // Core Love Features
    "love_compatibility_analysis": "Your Love Life Analysis",
    "relationship_potential_insights": "Relationship Potential Insights",
    "marriage_timing_predictions": "Marriage Timing Predictions",
    "soulmate_identification": "Soulmate Identification",
    "romantic_guidance_tips": "Romantic Guidance Tips",
    "pdf_download": "Comprehensive PDF Report",

    "what_you_get": "What Your Love Analysis Includes",
    "comprehensive_love_chart": "Comprehensive Love Chart",
    "romantic_compatibility_score": "Romantic Compatibility Score",
    "relationship_guidance": "Relationship Guidance",
    "marriage_timing_insights": "Marriage Timing Insights",

    // Actions & Buttons
    "pay_and_generate_analysis_love": "Get My Love Analysis",
    "processing_payment": "Processing Payment",
    "processing_request": "Generating Analysis",

    // Payment & Success Messages
    "thank_you": "Thank You",
    "payment_successful": "Payment Successful!",
    "love_analysis_processing": "Your love analysis is being prepared by our expert relationship astrologers. You'll receive detailed insights into your romantic destiny and compatibility patterns.",
    "order_id": "Order ID",
    "payment_id": "Payment ID",
    "amount_paid": "Amount Paid",

    // Delivery Information
    "delivery_information": "Delivery Information",
    "delivery_time": "Analysis Delivery",
    "within_12_hours_delivery_note_love": "Your detailed love report will be ready within 24 hours",
    "whatsapp_notification": "WhatsApp Updates",
    "whatsapp_delivery_note": "Receive instant notifications on WhatsApp",
    "email_delivery": "Email Delivery",
    "email_delivery_note": "Complete analysis delivered to",

    // What You'll Receive
    "what_youll_receive": "Your Love Analysis Package",
    "detailed_love_report": "Comprehensive Love Report (PDF)",
    "compatibility_analysis_detailed": "Detailed Compatibility Analysis",
    "relationship_timing_predictions": "Relationship Timing Predictions",
    "soulmate_characteristics": "Soulmate Characteristics Profile",
    "romantic_enhancement_tips": "Romantic Enhancement Tips",

    // Visual Content
    "sample_love_analysis": "Sample Love Analysis",
    "love_compatibility_score": "Your Love Life Score",
    "sample_love_reading": "High romantic potential with deep emotional connection",
    "sample_love_preview": "Preview of your personalized love analysis with compatibility insights",
    "love_analysis_categories": "Love Analysis Categories",

    // Love Category Types
    "compatibility": "Compatibility",
    "romance": "Romance",
    "marriage": "Marriage",
    "soulmate": "Soulmate",
    "attraction": "Attraction",
    "passion": "Passion",

    // Status & Processing
    "your_love_analysis_status": "Your Love Analysis Status",
    "processing_your_analysis": "Analyzing Your Love Patterns",
    "analysis_processing_message": "Our relationship astrology experts are studying your Venus position and 7th house to determine your romantic compatibility and love destiny.",
    "request_id": "Analysis ID",
    "status": "Status",
    "processing": "In Progress",
    "pending": "Queued",
    "email_notification_sent": "Confirmation email sent",
    "whatsapp_update_coming": "WhatsApp updates enabled",
    "delivery_within_12_hours": "Report ready within 12 hours",

    // Support & Contact
    "contact_support": "Contact Love Support",
    "need_help": "Need guidance?",
    "contact_us_at": "Reach us at",

    // Error Messages
    "please_fill_all_required_fields": "Please complete all required birth details",
    "payment_failed": "Payment unsuccessful. Please try again.",
    "processing_failed": "Analysis processing failed. Contact our support team.",

    // Love-Specific Elements
    "seventh_house": "7th House (Marriage House)",
    "venus_position": "Venus Position & Influence",
    "mars_influence": "Mars & Passion Indicators",
    "moon_emotions": "Moon & Emotional Compatibility",
    "jupiter_blessings": "Jupiter's Blessings in Love",
    "love_yogas": "Love & Marriage Yogas",

    // Compatibility Analysis
    "zodiac_compatibility": "Zodiac Sign Compatibility",
    "nakshatra_matching": "Nakshatra Compatibility",
    "guna_milan": "Guna Milan Analysis",
    "doshas_matching": "Dosha Compatibility Check",
    "planetary_harmony": "Planetary Harmony Score",
    "elemental_compatibility": "Elemental Compatibility",

    // Love Personality Analysis
    "romantic_nature": "Romantic Nature & Style",
    "love_language": "Your Love Language",
    "emotional_needs": "Emotional Needs in Relationships",
    "attraction_patterns": "Attraction Patterns",
    "relationship_approach": "Relationship Approach Style",
    "commitment_style": "Commitment & Loyalty Style",

    // Soulmate Analysis
    "soulmate_characteristics": "Soulmate Characteristics",
    "ideal_partner_traits": "Ideal Partner Traits",
    "soulmate_timing": "When You'll Meet Your Soulmate",
    "recognition_signs": "Soulmate Recognition Signs",
    "karmic_connections": "Karmic Love Connections",
    "twin_flame_indicators": "Twin Flame Indicators",

    // Marriage Predictions
    "marriage_timing": "Marriage Timing Predictions",
    "wedding_auspicious_dates": "Auspicious Wedding Dates",
    "married_life_forecast": "Married Life Forecast",
    "spouse_characteristics": "Spouse Characteristics",
    "marriage_compatibility": "Marriage Compatibility Score",
    "family_harmony": "Family Harmony Prospects",

    // Relationship Phases
    "dating_guidance": "Dating Phase Guidance",
    "courtship_period": "Courtship Period Insights",
    "engagement_timing": "Engagement Timing",
    "pre_marriage_guidance": "Pre-Marriage Guidance",
    "honeymoon_phase": "Honeymoon Phase Predictions",
    "long_term_relationship": "Long-term Relationship Forecast",

    // Love Challenges & Solutions
    "relationship_challenges": "Potential Relationship Challenges",
    "compatibility_issues": "Compatibility Issues to Address",
    "communication_style": "Communication Style Match",
    "conflict_resolution": "Conflict Resolution Guidance",
    "trust_building": "Trust Building Strategies",
    "intimacy_enhancement": "Intimacy Enhancement Tips",

    // Romantic Timing
    "love_favorable_periods": "Love Favorable Periods",
    "romantic_peak_times": "Romantic Peak Times",
    "proposal_timing": "Best Proposal Timing",
    "relationship_milestones": "Relationship Milestone Timing",
    "anniversary_significance": "Anniversary Significance",
    "renewal_periods": "Relationship Renewal Periods",

    // Venus Analysis
    "venus_sign_influence": "Venus Sign Influence",
    "venus_house_position": "Venus House Position",
    "venus_aspects": "Venus Planetary Aspects",
    "venus_dignity": "Venus Strength & Dignity",
    "venus_remedies": "Venus Enhancement Remedies",
    "venus_mantras": "Venus Love Mantras",

    // Love Types & Styles
    "passionate_love": "Passionate Love Indicators",
    "companionate_love": "Companionate Love Style",
    "romantic_love": "Romantic Love Expression",
    "unconditional_love": "Unconditional Love Capacity",
    "spiritual_love": "Spiritual Love Connection",
    "platonic_relationships": "Platonic Relationship Insights",

    // Compatibility Factors
    "mental_compatibility": "Mental Compatibility",
    "emotional_compatibility": "Emotional Compatibility",
    "physical_compatibility": "Physical Compatibility",
    "spiritual_compatibility": "Spiritual Compatibility",
    "lifestyle_compatibility": "Lifestyle Compatibility",
    "financial_compatibility": "Financial Compatibility in Marriage",

    // Love Remedies
    "love_enhancing_remedies": "Love Enhancing Remedies",
    "relationship_healing": "Relationship Healing Practices",
    "attraction_remedies": "Attraction Enhancement Remedies",
    "marriage_delay_remedies": "Marriage Delay Remedies",
    "love_gemstones": "Love & Relationship Gemstones",
    "romantic_rituals": "Romantic Rituals & Practices",

    // Past Life & Karma
    "past_life_love_connections": "Past Life Love Connections",
    "karmic_relationships": "Karmic Relationship Patterns",
    "soul_contracts": "Soul Contracts in Love",
    "karmic_debt_love": "Karmic Debt in Relationships",
    "spiritual_lessons_love": "Spiritual Lessons Through Love",
    "past_life_spouse": "Past Life Spouse Connections",

    // Love Forecast
    "monthly_love_forecast": "Monthly Love Forecast",
    "yearly_romance_predictions": "Yearly Romance Predictions",
    "love_life_phases": "Love Life Phases",
    "relationship_cycles": "Relationship Cycles",
    "romantic_opportunities": "Romantic Opportunities Ahead",
    "love_life_transformation": "Love Life Transformation Periods",

    // Special Love Scenarios
    "second_marriage": "Second Marriage Possibilities",
    "late_marriage": "Late Marriage Predictions",
    "love_marriage_vs_arranged": "Love Marriage vs Arranged Marriage",
    "intercaste_marriage": "Intercaste Marriage Prospects",
    "foreign_spouse": "Foreign Spouse Possibilities",
    "celebrity_romance": "High-Profile Romance Indicators",

    // Relationship Counseling
    "pre_marital_counseling": "Pre-Marital Astrological Counseling",
    "relationship_therapy": "Astrological Relationship Therapy",
    "couple_compatibility": "Couple Compatibility Enhancement",
    "marriage_counseling": "Marriage Counseling Insights",
    "relationship_revival": "Relationship Revival Guidance",
    "love_life_coaching": "Love Life Coaching",

    // Advanced Love Analysis
    "composite_chart_analysis": "Composite Chart Analysis",
    "synastry_compatibility": "Synastry Compatibility Reading",
    "davison_relationship_chart": "Davison Relationship Chart",
    "progressed_love_indicators": "Progressed Love Indicators",
    "solar_return_love": "Solar Return Love Predictions",
    "lunar_return_romance": "Lunar Return Romance Insights"
};
